module.exports = __webpack_public_path__ + "img/medal-no.a5312a57.svg";